import BaseColumnsDropzone from './BaseColumnsDropzone';
import ColumnsDropzone from './ColumnsDropzone';

export {
  BaseColumnsDropzone,
  ColumnsDropzone,
};



// WEBPACK FOOTER //
// ./src/components/ui/Dropzones/index.js